import React, { memo, useCallback, useMemo } from 'react';
import {
  Box,
  Button,
  ButtonProps,
  useBreakpointProp,
} from '@bonanza-social/moonlight';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { selectAccountDataState } from '@bonanza-social/account/state';
import { TextProps } from '@bonanza-social/moonlight/lib/common/Text/Text.types';
import { useStatusConfig } from './MainHeaderCTA.constants';
import { DimensionValue } from 'react-native';
import { useTransmitResolver } from '@bonanza-social/transmit-resolver';

function HeaderCTA(props: ButtonProps) {
  const dispatch = useDispatch();
  const accountDataState = useSelector(selectAccountDataState);

  const { shouldTransmit } = useTransmitResolver();

  const STATUS_CONFIG = useStatusConfig();

  const config = useMemo(() => {
    return STATUS_CONFIG.DEFAULT;

    //     // Check if we need to undo comment these later
    // return status && STATUS_CONFIG[status]
    //   ? STATUS_CONFIG[status]
    //   : STATUS_CONFIG.DEFAULT;
  }, [STATUS_CONFIG]);

  const textProps = useMemo<Pick<TextProps, 'locKey' | 'locNS'>>(
    () => config.textProps,
    [config],
  );

  const onPress = useCallback(() => {
    config.action(dispatch);
  }, [dispatch, config]);

  const minWidth = useBreakpointProp<DimensionValue>({
    desktop: 250,
    tablet: 250,
    mobile: 'auto',
  });

  return (
    <Box position="relative" minWidth={minWidth}>
      <Button
        {...textProps}
        loading={accountDataState === 'idle' || accountDataState === 'pending'}
        onPress={onPress}
        width="100%"
        {...props}
      />
      {shouldTransmit && (
        <Box
          position="absolute"
          top="space-0"
          right="space-0"
          transform={'translateY(-5px) translateX(5px)'}
          variant="gradient"
          width={12}
          height={12}
          borderRadius="radius-full"
          gradient="attentionBackground"
        ></Box>
      )}
    </Box>
  );
}

export default memo(HeaderCTA);
